<h1 mat-dialog-title>{{ getTittleMessage() }}</h1>
<div mat-dialog-content [innerHtml]="confirmMessage"></div>
<div mat-dialog-actions>
    <button i18n mat-raised-button class="mat-accent" (click)="dialogRef.close(true)">ОК</button>
    <button i18n mat-button (click)="dialogRef.close(false)">ОТМЕНА</button>
</div>